import createReactComponent from '../createReactComponent';
var PieChart = createReactComponent('PieChart', [['path', {
  d: 'M21.21 15.89A10 10 0 118 2.83',
  key: 'tc63e4'
}], ['path', {
  d: 'M22 12A10 10 0 0012 2v10z',
  key: 'wb6mft'
}]]);
export default PieChart;